export function icon(faClass, rawClass) {
  const el = document.createElement('i')
  el.setAttribute('class', rawClass || `fa fa-${faClass}`)
  return { dom: el }
}

export function fontAwesomeIcon(name) {
  return icon(null, `editor-font-awesome-v6 fa-regular fa-${name}`)
}
